import React from 'react'
import PropTypes from 'prop-types'
import LinksList from '../links-list'

import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const LegalLinks = ({variant, links, children}) => {
    const styles = useMultiStyleConfig('Footer')

    return (
        <LinksList links={links} linkStyle={styles.policies} {...styles.policies} variant={variant}>
            {children}
        </LinksList>
    )
}

LegalLinks.propTypes = {
    variant: PropTypes.oneOf(['vertical', 'horizontal']),
    links: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ),
    children: PropTypes.node,
}

export default LegalLinks
